<template>
    <div class="subscription-activity-view flex-between-wrapper">
        <div class="premium-activity-view">
          <h3 class="view-title">Set a reading routine for your class</h3>
          <p class="view-description">Practice makes perfect! With recurring activities and point goals, you can set a weekly reading routine that gives students regular practice. Easily check progress in real-time to see students’ performance!</p>
          <div class="button-wrapper">
            <primary-button @click="handleClickPlan">Choose your plan</primary-button>
          </div>
        </div>
        <img class="feature-image" src="/assets/app/class/activity-frame-bg.png">
    </div>
</template>

<script>

import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  components: {
    PrimaryButton
  },
  methods: {
    handleClickPlan() {
      this.$emit('showPlan');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-activity-view {
  padding-top: 74px;
  .premium-activity-view {
    max-width: 375px;
    margin-right: 10px;
  }
  .feature-image {
    margin-top: -20px;
  }
  @media(max-width: 900px) {
    display: block;
    padding-top: 50px;
    .premium-activity-view {
      max-width: none;
      margin: 0;
    }
    .feature-image {
      margin-top: 20px;
    }
  }
}
</style>
